import React from 'react'
import { EmptyStateSize } from 'shared/timber/v1/EmptyState'

import './Footer.scss'
import classy from 'shared/utils/classy'

export interface EmptyStateFooterProps {
  size?: EmptyStateSize
  appearance?: 'condensed' | 'default'
  children: React.ReactNode
  'data-testid'?: string
}

const EmptyStateFooter = React.memo(
  ({
    size = 'md',
    appearance = 'default',
    children,
    'data-testid': dataTestId = 'empty-state-footer',
  }: EmptyStateFooterProps) => {
    return (
      <footer
        className={classy(
          'EmptyStateFooter',
          `EmptyStateFooter--${size}`,
          `EmptyStateFooter--${appearance}`,
        )}
        data-size={size}
        data-appearance={appearance}
        data-testid={dataTestId}
      >
        {children}
      </footer>
    )
  },
)

EmptyStateFooter.displayName = 'EmptyState.Footer'

export default EmptyStateFooter
